import React, { ErrorInfo, ReactNode } from 'react';

interface Props {
    children: ReactNode;
}

interface State {
    hasError: boolean;
    error: Error | null;
    errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends React.Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null,
        errorInfo: null,
    };

    public static getDerivedStateFromError(error: Error): State {
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error, errorInfo: null };
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("Uncaught error:", error, errorInfo);
        this.setState({ error, errorInfo });
    }

    public render() {
        if (this.state.hasError) {
            return (
                <div className="p-6 max-w-2xl mx-auto mt-10 bg-white rounded-lg shadow-xl border border-red-200">
                    <h1 className="text-2xl font-bold text-red-600 mb-4">Algo salió mal.</h1>
                    <p className="mb-4 text-gray-700">
                        Se ha producido un error inesperado. Por favor, reporta este error al administrador.
                    </p>
                    <details className="whitespace-pre-wrap p-4 bg-gray-100 rounded text-sm overflow-auto max-h-96">
                        <summary className="cursor-pointer font-semibold mb-2">Ver detalles del error</summary>
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo && this.state.errorInfo.componentStack}
                    </details>
                    <button
                        onClick={() => window.location.reload()}
                        className="mt-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
                    >
                        Recargar página
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
